import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiChatStop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 28.5C10.7605 28.5 7.24476 27.0438 4.6005 24.3995C1.95625 21.7552 0.5 18.2395 0.5 14.5C0.5 10.7605 1.95625 7.24476 4.6005 4.6005C7.24476 1.95625 10.7605 0.5 14.5 0.5C18.2395 0.5 21.7552 1.95625 24.3995 4.6005C27.0438 7.24476 28.5 10.7605 28.5 14.5C28.5 18.2395 27.0438 21.7552 24.3995 24.3995C21.7552 27.0438 18.2395 28.5 14.5 28.5Z",
			fill: "#F7D2EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 1C10.894 1 7.50387 2.40424 4.95406 4.95406C2.40424 7.50387 1 10.894 1 14.5C1 18.106 2.40424 21.4961 4.95406 24.0459C7.50387 26.5958 10.894 28 14.5 28C18.106 28 21.4961 26.5958 24.0459 24.0459C26.5958 21.4961 28 18.106 28 14.5C28 10.894 26.5958 7.50387 24.0459 4.95406C21.4961 2.40424 18.106 1 14.5 1ZM14.5 0C22.5081 0 29 6.49187 29 14.5C29 22.5081 22.5081 29 14.5 29C6.49187 29 0 22.5081 0 14.5C0 6.49187 6.49187 0 14.5 0Z",
			fill: "url(#paint0_linear_270_15)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 7C16.5043 7 18.3865 7.77906 19.8037 9.19629C21.2209 10.6135 22 12.4957 22 14.5C22 16.5043 21.2209 18.3865 19.8037 19.8037C18.3865 21.2209 16.5043 22 14.5 22C12.4957 22 10.6135 21.2209 9.19629 19.8037C7.77906 18.3865 7 16.5043 7 14.5C7 12.4957 7.77906 10.6135 9.19629 9.19629C10.6135 7.77906 12.4957 7 14.5 7Z",
			fill: "white",
			stroke: "#E127AA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 11.5,
			width: 6,
			height: 6,
			fill: "#E127AA"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_270_15",
			x1: 14.5,
			y1: 0,
			x2: 14.5,
			y2: 29,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#E127AA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .483578,
					stopColor: "#ED7264"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FAC219"
				})
			]
		}) })
	]
});
export default SvgAiChatStop;
